import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';
import { useParams } from 'react-router-dom';
import { useUserRolePermissions } from 'hooks';
import { useRemoveTrailerMutation } from '../trailerStatusEndpoints';

const cardStyles = {
  boxShadow: 6,
  height: 115,
  width: 310,
};

export const LocationCardSkeleton = () => (
  <Card height={112}>
    <Box sx={{ p: 2, pb: 0 }}>
      <Skeleton variant="text" />
    </Box>
    <CardContent sx={{ display: 'flex', justifyContent: 'center' }}>
      <Skeleton
        sx={{ '&, :hover': { boxShadow: 'none' }, borderRadius: 2, height: 33, width: 104 }}
        variant="rectangular"
      />
    </CardContent>
  </Card>
);

const LocationCard = ({ locationId, title }) => {
  const { viewById: trailerId } = useParams();
  const { isDispatchingManage } = useUserRolePermissions();
  const [submit] = useRemoveTrailerMutation();

  const handleRemove = () => {
    submit({ locationId, trailerId });
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        slotProps={{
          title: { color: 'text.primary', variant: 'h6' },
        }}
        sx={{ p: 2, pb: 0 }}
        title={`${locationId} ${title.toUpperCase()}`}
      />
      {isDispatchingManage && (
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={handleRemove}
            sx={{ '&, :hover': { boxShadow: 'none' }, height: 33, width: 104 }}
            variant="outlined"
          >
            Remove
          </Button>
        </CardContent>
      )}
    </Card>
  );
};

LocationCard.propTypes = {
  locationId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

export default LocationCard;
